<template>
  <div class="document-container">
    <div class="document">
      <div class="is-flex">
        <div class="header-icon is-flex flex-align--center flex-justify--center">
          <font-awesome-icon :icon="['fa', 'user-circle']" class="has-text-grey-light" size="4x"/>
        </div>
        <div class="person-header--overview is-flex flex-direction--column">
          <div class="person-header--person is-flex">
            <div class="is-flex flex-direction--column flex-justify--center has-text-left">
              <span class="has-text-weight-bold is-size-3">
                {{ person.lastFirstName | parseName }}
              </span>
            </div>
            <div class="is-flex flex-direction--column flex-justify--center">
              <span class="has-text-weight-bold is-size-4">{{ person.localId }}</span>
              <span class="has-text-grey">Local ID</span>
            </div>
          </div>
        </div>
      </div>
      <div class="tabs-container no-border-top">
        <div class="tabs no-bottom-border">
          <ul>
            <li>
              <router-link
                class="is-uppercase"
                :to="{ path: 'directMatch'}"
                replace
              >
                direct match
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faUserCircle,
} from '@fortawesome/pro-regular-svg-icons';

export default {
  props: {
    person: {
      type: Object,
      required: true,
    },
  },
  filters: {
    parseName(name) {
      const names = name.split(', ');
      return `${names[1]} ${names[0]}`;
    },
  },
}
</script>

<style lang="sass" scoped>
  @import "~bulma/sass/utilities/initial-variables.sass"
  @import "~bulma/sass/utilities/mixins.sass"

  .header-icon
    padding: 1rem
  .person-header--overview
    flex-grow: 1
    margin-right: 1rem
  .person-header--person
    padding: 0.5rem 1rem
    justify-content: space-between
    border-bottom: 1px solid $grey-lighter
  @include from($tablet)
    .column
      border-left: 1px solid $grey-lighter
    .column:nth-child(1)
      border: none
</style>
